import React from 'react';
import { Link } from 'react-router-dom';

import { Flex, Text } from '@raystack/apsara';
import moment from 'moment';

import { DomainsFeedItem } from '@src/clients/beacon/api';
import { ReactComponent as CheckFilled } from '@src/icons/check-filled.svg';
import { ReactComponent as Check } from '@src/icons/check.svg';
import { ReactComponent as CrossFilled } from '@src/icons/cross-filled.svg';

import { getNotificationDetails } from './events';

import styles from './styles.module.css';

interface NotificationItemProps {
  message: DomainsFeedItem;
  markAsRead: (message: DomainsFeedItem, close: boolean) => void;
}

export default function NotificationItem({
  message,
  markAsRead
}: NotificationItemProps) {
  const { status, icon: Icon } = getNotificationDetails(message.event || '');

  const msgTime = moment(message?.timestamp).fromNow();
  const url = message?.action_url || '';

  function onClick() {
    markAsRead(message, Boolean(url));
  }

  function onReadClick(e: React.MouseEvent<HTMLElement>) {
    e.stopPropagation();
    e.preventDefault();
    markAsRead(message, false);
  }

  const isRead = message.status === 'read';

  return (
    <Link to={url} onClick={onClick} data-test-id='notification-item'>
      <Flex className={styles.noticationItem} gap={'medium'} data-read={isRead}>
        <div className={styles.iconWrapper}>
          <Icon className={styles.icon} />
          {status ? (
            status === 'success' ? (
              <CheckFilled
                color='var(--rs-color-foreground-success-primary)'
                className={styles.statusIcon}
              />
            ) : (
              <CrossFilled
                color='var(--rs-color-foreground-danger-primary)'
                className={styles.statusIcon}
              />
            )
          ) : null}
        </div>
        <Flex gap={'small'} justify='between' style={{ flex: 1 }}>
          <Flex gap={'small'} direction={'column'}>
            <Text
              size={3}
              dangerouslySetInnerHTML={{ __html: message.message_text || '' }}
            />
            <Text size={2} variant='secondary'>
              {msgTime}
            </Text>
          </Flex>
          {isRead ? (
            <span className={styles.readBtn} />
          ) : (
            <Flex
              className={styles.readBtn}
              gap={'extra-small'}
              onClick={onReadClick}
              data-test-id='notification-item-read-btn'
            >
              <Check />
              <Text variant='secondary'>Read</Text>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Link>
  );
}
